import getPlayerStoryParams from '@gameday/core/datasources/helpers/getPlayerStoryParams';

const topPerformersWithStoriesDataRequestAction = () => {
    return (dispatch, getState, { componentDataEngine }) => {
        const state = getState();
        const { gamePk } = state.gumbo;
        const { players, gamePk: topPerformersGamePk } = state.topPerformers;
        const { locale, language } = state.views;

        if (players?.length > 0 && topPerformersGamePk === gamePk) {
            /* if we already have topPerformers data for this game
            * from the boxscore source, bypass the spotlightGame stitch
            */
            dispatch({
                type: 'top_performer_loading',
                data: { isLoadingStories: true }
            });
            const topPerformerIds = players.map(player => player.id);
            const params = getPlayerStoryParams(topPerformerIds);
            return componentDataEngine
                .fetchAndStore('playerStory', { ...params, winnerIds: topPerformerIds, language })
                .catch((playerStoryError) =>
                    componentDataEngine.store(playerStoryError)
                );
        }
        dispatch({
            type: 'top_performer_loading',
            data: { isLoadingStories: true, isLoadingTopPerformers: true }
        });
        return componentDataEngine
            .fetch('spotlightGame', { gamePk, locale })
            .then((spotlightGameRes) => {
                const topPerformerIds = spotlightGameRes.data.players.map(player => player.id);
                componentDataEngine.store(spotlightGameRes);
                const params = getPlayerStoryParams(topPerformerIds);
                componentDataEngine
                    .fetchAndStore('playerStory', { ...params, winnerIds: topPerformerIds, language })
                    .catch((playerStoryError) =>
                        componentDataEngine.store(playerStoryError)
                    );
            });
    };
};

export default topPerformersWithStoriesDataRequestAction;
